import { render } from "./UpdateProfile.vue?vue&type=template&id=01e4849a&ts=true"
import script from "./UpdateProfile.vue?vue&type=script&lang=ts"
export * from "./UpdateProfile.vue?vue&type=script&lang=ts"

import "./UpdateProfile.vue?vue&type=style&index=0&id=01e4849a&lang=css"
import "./UpdateProfile.vue?vue&type=style&index=1&id=01e4849a&lang=css"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__